export const ANNOTATION_SURFACE_TOOLTIPS = {
  surface: "Capture editorial notes from this frame.",
  context: "This note will anchor to the current frame of the active clip.",
  linkedAudio: "Linked audio is available for sound-based notes.",
  timeFrame: "This is the timeline anchor for the annotation.",
  draft: "Type or dictate what matters here.",
  action: "Capture the next action or editorial follow-up.",
  creative: "Note storytelling or performance intent.",
  continuity: "Flag mismatches between shots or actions.",
  timing: "Mark pacing or cut-timing issues.",
  audio: "Flag sound, sync, or cue timing issues.",
  npc: "Capture NPC beats, triggers, or behavior notes anchored to this frame.",
  intent: "Capture the intended feeling or narrative purpose.",
  publishKind: "Mark this as a note intended for review or handoff.",
  dropMarker: "Place a lightweight marker here.",
  publishAnnotation: "Save this as structured editorial metadata.",
  publishAndClose: "Save this annotation and close the surface.",
  close: "Dismiss the annotation surface without publishing.",
  dictate: "Speak a note for this frame.",
} as const;